import { ThemeHelper } from '@ark-technical-modules/ark-utils';

ThemeHelper.setTheme('light');
